import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import Navbar from "../../commons/Navbar/Navbar";
import Sidebar from "../../commons/Sidebar/Sidebar";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        height: "100vh",
        overflowX: 'hidden'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: theme.palette.ascents.baseDark,
        boxShadow: 'none'
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
        color: theme.palette.ascents.primary,
        [theme.breakpoints.down("sm")]: {
            marginRight: 0,
        },
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        "& .MuiDrawer-paper": {
            backgroundColor: theme.palette.ascents.baseDark,

            position: "relative",

            '&:after': {
                content: "''",
                position: "absolute",
                right: "0px",
                top: 0,
                width: "2px",
                height: "100%",
                background: `linear-gradient(180deg,${theme.palette.ascents.primary} 20%,${theme.palette.ascents.orange} 70%)`
            },
        }
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("sm")]: {
            width: '95%',
        },
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7) + 1,
        [theme.breakpoints.down("sm")]: {
            width: 0,
        },
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        "& .MuiSvgIcon-root": {
            color: theme.palette.ascents.primary
        }
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        overflow: "auto",
        zIndex: 1205,
        position: "relative"
    },
    listItem: {
        "&.MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover": {
            // background: styledBy("listItemAscent", theme.palette.ascents)
        }
    },
    menuIcon: {
        width: '1.5rem',
        height: '1.5rem',
        marginRight: 10,
    }
}));

const BaseLayout = ({
    children,
    accent = "white",
    listItemAscent = "primary",
}) => {
    const classes = useStyles({ accent, listItemAscent });
    const [open, setOpen] = useState(window.screen.width >= 600);

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Sidebar
                classes={classes}
                openSidebar={open}
                setOpenSidebar={setOpen}
            />
            <main className={classes.content}>
                <Navbar
                    classes={classes}
                    openSidebar={open}
                    setOpenSidebar={setOpen}
                />
                <div className={classes.toolbar} />
                {children}
            </main>
        </div>
    );
}
export default BaseLayout;